// extracted by mini-css-extract-plugin
module.exports = {"userPanel":"SupplierPanel_userPanel__2heS8","deleteButton":"SupplierPanel_deleteButton__16Zbq"};